import { render, staticRenderFns } from "./LuminousGroveSuite.vue?vue&type=template&id=a15298d6&scoped=true"
import script from "./LuminousGroveSuite.vue?vue&type=script&lang=js"
export * from "./LuminousGroveSuite.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/roomdetail.css?vue&type=style&index=0&id=a15298d6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15298d6",
  null
  
)

export default component.exports